module.exports = __webpack_public_path__ + "static/media/sn_vk.ecca37be.svg";